import gql from "graphql-tag";

export default gql`
	input JustErrorInput {
		name: String!
		message: String
	}

	type JustError {
		name: String!
		message: String
	}

	input UnexpectedErrorInput {
		id: ID!
		code: Int
		message: String
		stack: String
		originalError: JustErrorInput
	}

	type UnexpectedError {
		id: ID!
		code: Int
		message: String
		stack: String
		originalError: JustError
	}

	extend type Query {
		unexpectedError: UnexpectedError
	}

	extend type Mutation {
		setUnexpectedError(error: UnexpectedErrorInput): Boolean
		resetUnexpectedError: Boolean
	}
`;
